// extracted by mini-css-extract-plugin
export default {"typography":"styles_typography__+SGtB"};